<pagination-template #p="paginationApi"
                     [id]="config.id"
                     (pageChange)="config.currentPage = $event; resetActions(config.id)">

  <div *ngIf="p.pages.length > 1" class="pagination ngx-pagination">
    <div class="page-item">
      <button role="button"
              [disabled]="p.isFirstPage()"
              (click)="p.setCurrent(1)"
              class="btn btn-outline-info">
              <i class="icon-control-start"></i>
      </button>
    </div>

    <div class="page-item">
      <button role="button"
              [disabled]="p.isFirstPage()"
              (click)="p.previous()"
              class="btn btn-outline-info">
              <i class="icon-arrow-left"></i>
      </button>
    </div>

    <div class="page-item">
      <input
        required type="text" class="form-control"
        (input)="p.setCurrent(filterPage($event.target.value, p.pages))" [value]="config.currentPage"
      >
    </div>

    <div class="page-item">
      <button role="button"
              [disabled]="p.isLastPage()"
              class="btn btn-outline-info"
              (click)="p.next()">
              <i class="icon-arrow-right"></i>
      </button>
    </div>
  </div>

</pagination-template>
